var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF Doc Icon 1",
    clipPath: "url(#clip0_394_762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF-Doc-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4404 21.8876C21.4404 22.4748 20.9642 22.9509 20.377 22.9509H5.33395C4.74673 22.9509 4.27069 22.4748 4.27069 21.8876V2.108C4.27069 1.52078 4.74673 1.04474 5.33395 1.04474H14.3077V6.31688C14.3077 6.72037 14.6348 7.04743 15.0384 7.04743H21.4404V21.8876ZM21.4404 6.08823L15.5822 1.04474L14.3662 -0.00219727H14.3077H5.33395C4.17039 -0.00219727 3.22375 0.94444 3.22375 2.108V21.8876C3.22375 23.0512 4.17039 23.9978 5.33395 23.9978H20.377C21.5407 23.9978 22.4873 23.0512 22.4873 21.8876V7.04743V6.98954L21.4404 6.08823Z",
    fill: "#C33228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.042 20.2142H1.75391C1.07828 20.2142 0.530518 19.6664 0.530518 18.9906V11.0301C0.530518 10.3545 1.07828 9.8067 1.75391 9.8067H16.042C16.7176 9.8067 17.2654 10.3545 17.2654 11.0301V18.9906C17.2654 19.6664 16.7176 20.2142 16.042 20.2142Z",
    fill: "#C33228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49539 13.536C5.37404 13.4343 5.20417 13.3836 4.98538 13.3836H4.12167V14.7341H4.98538C5.20417 14.7341 5.37404 14.6792 5.49539 14.569C5.61675 14.4592 5.67749 14.285 5.67749 14.0464C5.67749 13.8078 5.61675 13.6378 5.49539 13.536ZM6.22698 15.1884C5.95849 15.4124 5.57515 15.5244 5.0767 15.5244H4.12167V17.1737H3.16943V12.5868H5.13877C5.59282 12.5868 5.9549 12.7051 6.22486 12.9416C6.49482 13.1782 6.62973 13.5442 6.62973 14.0401C6.62973 14.5815 6.49548 14.9643 6.22698 15.1884Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32887 13.3836V16.3771H9.21399C9.66698 16.3771 9.98279 16.1541 10.1614 15.7081C10.2591 15.4632 10.308 15.1717 10.308 14.8336C10.308 14.3668 10.2348 14.0086 10.0882 13.7584C9.94185 13.5085 9.65036 13.3836 9.21399 13.3836H8.32887ZM10.0861 12.6865C10.4079 12.7923 10.6685 12.9863 10.8679 13.2685C11.0277 13.4967 11.1367 13.7435 11.1949 14.009C11.253 14.2745 11.2821 14.5276 11.2821 14.7683C11.2821 15.3783 11.1595 15.8948 10.9146 16.318C10.5823 16.8885 10.0696 17.1738 9.37601 17.1738H7.39844V12.5869H9.37601C9.6606 12.5911 9.89719 12.6242 10.0861 12.6865Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 12.5931H15.2712V13.399H12.953V14.454H14.9849V15.2507H12.953V17.1738H12.0007V12.5931Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9568,
    height: 24,
    fill: "white",
    transform: "translate(0.530518 -0.00219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPdfIcon);
export default __webpack_public_path__ + "static/media/new-pdf-icon.1ec1c785b89627d0f913cfd4ec136c75.svg";
export { ForwardRef as ReactComponent };